// import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Footer = () => (
  <FooterContainer>
    {/* ... existing footer content ... */}
    <div className="bottom">
      <p>© 2026 Govind Industries. All Rights Reserved.</p>
      {/* <div className="legal-links">
        <Link to="/privacy">Privacy Policy</Link> | <Link to="/terms">Terms & Conditions</Link>
      </div> */}
    </div>
  </FooterContainer>
);

const FooterContainer = styled.footer`
  background: ${props => props.theme.colors.secondary};
  color: white;
  padding: 3rem 5% 1rem;
  margin-top: 4rem;
  
  .content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
    
    @media (max-width: 768px) {
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      gap: 1.5rem;
    }
    
    @media (max-width: 480px) {
      grid-template-columns: 1fr;
      gap: 1rem;
      text-align: center;
    }
  }
  
  .bottom {
    text-align: center;
    border-top: 1px solid #444;
    padding-top: 1rem;
    font-size: 0.8rem;
    
    @media (max-width: 768px) {
      font-size: 0.75rem;
      padding-top: 0.875rem;
    }
    
    @media (max-width: 480px) {
      font-size: 0.7rem;
      padding-top: 0.75rem;
    }
  }
  
  h4 {
    font-size: 1.1rem;
    margin-bottom: 1rem;
    color: ${props => props.theme.colors.primary};
    
    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 0.875rem;
    }
    
    @media (max-width: 480px) {
      font-size: 0.95rem;
      margin-bottom: 0.75rem;
    }
  }
  
  p, a {
    font-size: 0.9rem;
    line-height: 1.5;
    
    @media (max-width: 768px) {
      font-size: 0.85rem;
    }
    
    @media (max-width: 480px) {
      font-size: 0.8rem;
    }
  }
  
  @media (max-width: 768px) {
    padding: 2.5rem 4% 0.875rem;
    margin-top: 3rem;
  }
  
  @media (max-width: 480px) {
    padding: 2rem 3% 0.75rem;
    margin-top: 2rem;
  }
`;

export default Footer;